import ObjectType from './ObjectType';
const NumberType = Object.seal({
    fullName: 'Number',
    name: 'Number',
    namespace: '',
    baseType: ObjectType,
    isArray: false,
    factory: Number,
});
export default NumberType;
